import styled from 'styled-components';
import { SIZE, LAYERS } from 'common/sizes';
import { DEFAULT_FONT_FAMILY } from 'common/constants';
import { ButtonWrapper } from 'common/baseComponents'

export const LeftActions = styled.div`
    display:flex;
    margin-left: ${SIZE.THREE}px;
    align-items: center;
    position: relative;
`

export const RightActions = styled.div`
    display:flex;
    margin-right: ${SIZE.THREE}px;
    align-items: center;
    position: relative;
`

export const ActionBar = styled.div`
    background-color: #FFF;
    height:${SIZE.SIX}px,
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 0 0 3px 3px;
    z-index: ${LAYERS.LAYER_3};
    flex: 0 0 auto;
    ${LeftActions} {
        margin: 0 0 0 ${SIZE.ONE}px;
    };
    ${RightActions} {
        margin: 0 ${SIZE.ONE}px 0 0;
    };
`;

export const HelperCalloutMessage = styled.span`
    position: absolute;
    top: -${SIZE.FIVE}px;
    left: ${SIZE.NINE}px;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 12px;
    letter-spacing: 1.25px;
    min-width: ${SIZE.TEN}px;
    max-width: ${SIZE.SEVENTYTHREE}px;
    border-radius: 3px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.27);
    border: solid 1px #f1f2f6;
    background-color: #FFF;
    display: none;
    padding: ${SIZE.HALF}px
    z-index:900;
    text-align: center;
    white-space: nowrap;
    &:hover{
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
`

export const ActionBarButtonWrapper = styled(ButtonWrapper)`
    &:hover {
        cursor: pointer;
    };
    &:hover + ${HelperCalloutMessage} {
        display: flex;
        justify-content: center;
        align-items: center; 
    }
`
